import { render } from "./TransitaireDossiers.vue?vue&type=template&id=1426d0db&scoped=true&ts=true"
import script from "./TransitaireDossiers.vue?vue&type=script&lang=ts"
export * from "./TransitaireDossiers.vue?vue&type=script&lang=ts"

import "./TransitaireDossiers.vue?vue&type=style&index=0&id=1426d0db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1426d0db"]])

export default __exports__